import React, {useContext} from "react"
import PropTypes from "prop-types";
import Form from "components/Form";
import VS from "constants/ValidationShema";
import Tr from "translations/Translations";
import Select, {createSelectItem} from "components/Select";
import {ContractorConsorciumTypes, ContractorConsorciumTypesLabel, ContractorConsorciumTypesOnePosition} from "constants/ContractorConsorciumTypes";
import ConsorciumTable from "./ConsorciumTable";
import {ContractorCompanySize, ContractorCompanySizeLabel} from "constants/ContractorCompanySize";
import SaveFormikValues from "components/SaveFormikValues";
import TextInput from "components/TextInput";
import INPUT_TYPE from "constants/INPUT_TYPE";
import {connect} from "react-redux";
import Typography from "components/Typography";
import {DemandValidationSectionStatus} from "constants/DemandValidationSectionStatus";
import GridBlock from "components/GridBlock";
import WorkableButton from "components/button/WorkableButton";
import getObjectValue from "libs/getObjectValue";
import SupportModeContext from "context/SupportModeContext";
import PurchaserOfferContext from "context/PurchaserOfferContext";

function OfferCommonDataForm(
    {
        offerEdit,
        section,
        onSubmit,
        formId,
        working,
        disabled,
        formSubmit
    }) {

    const handleSubmit = () => formSubmit[formId]();
    const supportMode = useContext(SupportModeContext);
    const purchaserOfferContext = useContext(PurchaserOfferContext);

    const validationSchema = () => VS.lazy((value) => {

        const shape = {
            consorciumType: VS.string(),
            companySize: VS.string(),
        }

        if (value.consorciumType === ContractorConsorciumTypes.ALL) {
            shape.consorciants = VS.arrayRequired("consorciant_required")
        }

        if (section.digitalSign)
            shape.requiredSignatures = VS.integerMinMax(1, 99)
        return VS.object(shape);
    })


    return (<Form
        initialValues={offerEdit.commonData}
        validationSchema={validationSchema()}
        onSubmit={onSubmit}
        id={formId}
    >
        {(formikProps) => (<>

            {!disabled && (section.digitalSign || !offerEdit.commonData.hadStageWithOffer) ?
                <GridBlock justify='space-between'>
                    <Typography
                        color='error'>{offerEdit.commonData.status === DemandValidationSectionStatus.ERROR ? Tr("fill_missing_data_x", {name: 'contractor_company_data'}, true) : null}</Typography>
                    <WorkableButton working={working} disabled={working || !formikProps.dirty || supportMode || purchaserOfferContext?.preview} onClick={handleSubmit}>{Tr('save_changes')}</WorkableButton>
                </GridBlock> : <br/>
            }

            <SaveFormikValues
                formikProps={formikProps}
                id={formId}
            />

            <Select
                formikProps={formikProps}
                id="consorciumType"
                label={Tr('consorcium')}
                items={Object.keys(section.onePositionMode ? ContractorConsorciumTypesOnePosition : ContractorConsorciumTypes).map(key => createSelectItem(key, ContractorConsorciumTypesLabel(key)))}
                required
                disabled={disabled || offerEdit.commonData.hadStageWithOffer}

            />
            {formikProps.values.consorciumType === ContractorConsorciumTypes.ALL && <>
                <ConsorciumTable
                    disabled={disabled || offerEdit.commonData.hadStageWithOffer}
                    formikProps={formikProps}
                    id='consorciants'
                    contractor={offerEdit.contractor}
                    companySize={getObjectValue("companySize", formikProps.values, null)}
                />
                <br/>
            </>}

            <Select
                formikProps={formikProps}
                id="companySize"
                label={Tr('contractor_company_size')}
                items={Object.keys(ContractorCompanySize).map(key => createSelectItem(key, ContractorCompanySizeLabel(key)))}
                required
                disabled={disabled || offerEdit.commonData.hadStageWithOffer}
            />

            {section.digitalSign &&
                <TextInput
                    formikProps={formikProps}
                    label={Tr('required_signatures_count')}
                    id='requiredSignatures'
                    type={INPUT_TYPE.INTEGER_POSITIVE_AMOUNT}
                    required
                    disabled={disabled}
                />
            }


        </>)}
    </Form>)

}

OfferCommonDataForm.propTypes = {
    offerEdit: PropTypes.shape({
        commonData: PropTypes.shape({
            consorciumType: PropTypes.string.isRequired,
            consorciants: PropTypes.array,
            companySize: PropTypes.string,
            requiredSignatures: PropTypes.number
        })
    }),
    section: PropTypes.shape({
        onePositionMode: PropTypes.bool.isRequired,
        digitalSign: PropTypes.bool.isRequired
    }).isRequired,
    onSubmit: PropTypes.func.isRequired,
    formId: PropTypes.string.isRequired,
    working: PropTypes.bool.isRequired,
    disabled: PropTypes.bool.isRequired,
}
export default connect((state) => ({
    formSubmit: state.form,
}), {})(OfferCommonDataForm);